"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var fontFamily = "'Titillium Web', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
exports.darkTheme = styles_1.createMuiTheme({
  typography: {
    fontFamily: fontFamily
  },
  palette: {
    type: 'dark',
    background: {
      default: '#262525'
    },
    primary: {
      main: '#ee7268',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#32c688',
      contrastText: '#ffffff'
    },
    error: {
      main: '#ee7268',
      contrastText: '#ffffff'
    }
  }
});
exports.lightTheme = styles_1.createMuiTheme({
  typography: {
    fontFamily: fontFamily
  },
  palette: {
    type: 'light',
    background: {
      default: '#262525'
    },
    primary: {
      main: '#ee7268',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#32c688',
      contrastText: '#ffffff'
    },
    error: {
      main: '#ee7268',
      contrastText: '#ffffff'
    }
  }
});
exports.default = exports.darkTheme;